import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Row, Col, Spin } from "antd";
export function Loading() {
    return (_jsx(Row, { justify: "center", align: "middle", style: { minHeight: "100vh" }, children: _jsx(Col, { span: 24, style: { textAlign: "center" }, children: _jsx(Spin, { size: "large" }) }) }));
}
